<template>
<div class="row specials-row" v-if="link && link.uid">
    <div class="row special-box">
        <div class="col-md-8 col-sm-12 special-text text-center">
            <p>Check out our seasonal specials available in limited quantities and on a first come first serve basis.</p>
            <span class="bonjour-button" v-on:click.self="goTo">View Specials</span>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-0 special-icon"><img class="special-img img-fluid" src="../assets/img/dot-box.svg"></div>
        <div class="col-lg-2 col-md-0 col-sm-0"></div>
    </div>
</div>
</template>
<script>
export default {
    name: 'Special',
    props: ['link'],
    methods: {
        goTo(){
            this.$router.push('/content/' + this.link.uid);
        }
    }
}
</script>
<style lang="scss">
.specials-row {
   // padding-top: 100px;
    padding-bottom: 20px;
    margin-left: 0px;
    margin-right: 0px;
    .col-sm-0 {
        @media (max-width: 760px){
            display: none;
        }
    }
    .col-md-0 {
        @media (max-width: 1000px){
            display:none;
        }
    }
    .special-box {
        width: 100%;
        background-color: #300B02;
        margin-left: 0px;
        margin-right: 0px;
    }
   
    .special-icon {
        background-color: #fff;
    }
    .special-text {
        p {
            width: 50%;
            margin-left: auto;
            margin-right: auto;
            font-family: "raleway",sans-serif;
            margin-bottom: 25px;
        }
        color: #FFEDD6;
        font-size: 15pt;
        padding-top: 30px;
        padding-bottom: 20px;
        .bonjour-button {
            padding: 10px;
            border: 1px solid #ffedd6;
            border-radius: 5px;
            font-family: "raleway",sans-serif;
            font-weight: 100;
            margin-top: 40px;
            &:hover {
                background-color: #ffedd6;
                color: #300B02;
                cursor: pointer;
            }
        }
    }
}
</style>